﻿import { defineComponent, PropType } from 'vue';

import { Payment } from "../../../services/payment";

const Pay: Payment = new Payment();
const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

import { payment_response } from "../../../objects/ttc/payment_response/response";
import { resp } from "../../../objects/ttc/payment_response/resp";
import { response } from "../../../objects/v1_3/payment/initialise/response";

import { response_method } from "../../../objects/v1_3/payment/initialise/response_method";
import { booking_search_group } from "../../../objects/v1_2/Booking_Details/booking_search_group";

import { payment } from "../../../objects/ttc/payment_gateway/payment";
import { request_payment_initialise_internal } from "../../../objects/v1_3/payment/initialise/request_payment_initialise_internal";
import { payment_transaction } from 'modules/tms/booking_engine/objects/ttc/payment_gateway/payment_transaction';

export default defineComponent({
    name: "payment_credit_card",
    props: {
        consumer_display: String,
        credit_card_div: String,
        cybersource_div_button: String,
        cybersource_div_frame: String,
        cybersource_iframe: HTMLElement
    },
    data() {
        return {
            payment_response: new resp() as resp,
            initialised_payment: false as boolean,
            ttc_payment_form: false as boolean,
            finalised_payment: true as boolean,
            storepaymentResponse: new payment_response() as payment_response,
            cybersource_url: "",
            paymentiframe_cybersource_url: "",
            showAltUrl: false,
            is_payment_method_payment_gateway: false as boolean,
            is_payment_method_cybersource: false as boolean,
            is_iFrame: true as boolean,
            hide_payment_ttcgateway : true as boolean,
            hide_payment_cybersource_button : true as boolean,
            hide_payment_cybersource_iframe : true as boolean
        }
    },
    methods: {
        get_Booking(): booking_search_group {
            return this.$store.getters.get_Booking;
        },
        async check_out_page() {
            this.is_payment_method_payment_gateway = (import.meta.env.VITE_PAMENT_METHOD == 'ttc_payment_gateway');
            this.is_payment_method_cybersource = (import.meta.env.VITE_PAMENT_METHOD == 'cybersource');
            this.is_iFrame = JSON.parse(import.meta.env.VITE_PAMENT_CYBERSOURCE_USE_IFRAME);

            if (this.is_payment_method_cybersource && this.is_iFrame) {
                window.addEventListener("message", this.cybersource_confirmation_redirect, false);
            }

            if (this.$store.getters.get_Agent_Login?.payment_methods.length > 0) {
                if (this.$store.getters.get_Agent_Login.payment_methods[0].method == "CC") {
                    if (this.consumer_display == "false") {
                        await this.Initialise_Payment(false, this.$store.getters.get_Selected_Payment.nett_gross == "N");
                    }
                } else {
                    this.initialised_payment = true;
                    this.ttc_payment_form = true;
                    this.finalised_payment = true;
                }
            } else {
                if (this.consumer_display == "true") {
                    await this.Initialise_Payment(true, this.$store.getters.get_Selected_Payment.nett_gross == "N");
                }
            }
        },
        Get_Payment_App_Id(): string {
            let payment_app_id : any = import.meta.env.VITE_PAYMENT_APP_ID; //default
            if (this.$store.getters.get_Payment_APP_ID != null && this.$store.getters.get_Payment_APP_ID != '') {
                payment_app_id = this.$store.getters.get_Payment_APP_ID; //set by paylink
            }
            return payment_app_id;
        },
        has_Payment_Session() : boolean {
            let Payment_Session = this.$store.getters.get_Payment_Session;
            if (!(Payment_Session == undefined || Payment_Session == null || Payment_Session.payment_session == null)) {
                return true;
            }
            return false;
        },
        async Initialise_Payment(consumer_sale: boolean, nett_sale: boolean) {
            var is_Full_Payment : boolean = this.$store.getters.get_Payment_Full_Payment;
            var is_Deposit_Payment : boolean = this.$store.getters.get_Payment_Deposit;
            var get_Booking = this.$store.getters.get_Booking;
            var is_consumer_sale = consumer_sale;
            var is_nett_sale = nett_sale;
            
            let payment_session : request_payment_initialise_internal | null = null;
            if (this.has_Payment_Session()) {
                payment_session = this.$store.getters.get_Payment_Session;

                //var is_Full_Payment : boolean = payment_session.payment_initialise.full_payment ?? true;
                //var is_Deposit_Payment : boolean = payment_session.payment_initialise.deposit ?? false;
                get_Booking = payment_session?.get_booking;
                is_nett_sale = payment_session?.payment_initialise.nett_sale ?? false;
            }

            let Payment_Initialise: response = await Pay.Payment_Initialise(is_Full_Payment, is_Deposit_Payment, get_Booking, payment_session, this.$store.getters.get_Agent_Login, is_consumer_sale, is_nett_sale, this.Get_Payment_App_Id()).then(response => { return response.json(); })
            let Payment_Method: response_method = Pay.Payment_Method(Payment_Initialise);

            await Pay.get_cybersource_url(Payment_Initialise);
            let Payment_Transation: payment = new payment();      
            if (Payment_Method.data_payload != null) {
                let Payment_Transation: payment = JSON.parse(Payment_Method.data_payload ?? "");      
            }

            Payment_Transation.transactionInfo.bookingType = "CD";

            if(!this.isAgent_Login()) {
                Payment_Transation = this.setBlankDefaultAddress(Payment_Transation);
            }
            this.payment_response.ttc = Payment_Transation

            this.initialised_payment = true;
            this.ttc_payment_form = false;
            this.finalised_payment = true;

            this.cybersource_url = Pay.get_cybersource_url(Payment_Initialise);
            
            if (this.is_payment_method_payment_gateway) {
                this.hide_payment_ttcgateway = (!this.is_payment_method_payment_gateway);
                window.ttcPaymentgateway.attachPaymentOption(JSON.stringify(Payment_Transation), "#" + this.credit_card_div, (paymentResponse: payment_response) => {
                    this.Payment_Processed(paymentResponse);
                });
            } 
            else if (this.is_payment_method_cybersource) {
                this.paymentiframe_cybersource_url = this.cybersource_url;
                this.hide_payment_cybersource_button = (!this.is_payment_method_cybersource || (this.is_payment_method_cybersource && this.is_iFrame))
                this.hide_payment_cybersource_iframe = (!this.is_payment_method_cybersource || (this.is_payment_method_cybersource && !this.is_iFrame))
            }
        },
        redirect_to_cybersource() {
            window.location.href = this.cybersource_url; // full page
        },
        cybersource_confirmation_redirect(event) {
            if(event.origin !== import.meta.env.VITE_DEFAULT_URL && event.origin !== 'http://localhost:3001') return;

            if (import.meta.env.VITE_PAMENT_METHOD == 'cybersource') this.$router.push({ path: "/confirmation" });
        },
        isAgent_Login(): boolean {
            return this.$store.getters.get_Agent_Login?.valid_login == true;
        },
        onLoadIframe(event) {
        },
        async Payment_Processed(Payment_Response: payment_response) {
            this.payment_response.response_payment = Payment_Response;

            if(Payment_Response?.paymentSuccessful == false) {
                this.$router.push({name: 'failed_payment', params: { reason: "reason="+Payment_Response?.paymentStatus}});
            }
            else if (Payment_Response?.paymentSuccessful != null) {
                this.finalised_payment = false;
                this.ttc_payment_form = true;
                this.showAltUrl = false;
                
                let Return_Status = await Pay.Commit_Payment(this.payment_response, this.Get_Payment_App_Id());

                this.$router.push({ path: "/confirmation" });
            }

            this.finalised_payment = true;
        },
        setBlankDefaultAddress(payment: payment): payment {
            payment.transactionInfo.addressCity = "";
            payment.transactionInfo.addressCountry = "";
            payment.transactionInfo.addressLine1 = "";
            payment.transactionInfo.addressLine2 = "";
            payment.transactionInfo.addressPostalCode = "";

            return payment;

        },
        openCyberSource() {
            window.open(this.cybersource_url, "_blank"); //_self
        },
        GetBrand(): string {
            return String(import.meta.env.VITE_DEFAULT_CLASS);
        }
    },
    mounted() {
        this.check_out_page();
    }
})